import { render, staticRenderFns } from "./IconTypeformStatement.vue?vue&type=template&id=7b7aa45c&"
import script from "./IconTypeformStatement.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformStatement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports